export function getLinkTarget(url: string): '_self' | '_blank' {
    try {
        const parsedUrl = new URL(url, globalThis.window.location.href)
        const parsedLojaUrl = new URL(globalThis.window.location.href)

        return parsedUrl.hostname !== parsedLojaUrl.hostname ? '_blank' : '_self'
    } catch {
        return '_self'
    }
}